import styled from 'styled-components';

export const CardContainer = styled.div`
  width: 100%;

  height: auto;
  background-color: ${({ theme }) => theme.palette.white};
  display: flex;
  flex-direction: row;
  position: relative;
  z-index: 9;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 15px 15px 20px;
  }
`;
